import type { MenuItem } from '@/types';

/**
 * Web docs menu
 */
export const webDocs: MenuItem[] = [
  { label: 'Overview', path: '/sdk_ref/web' },
  {
    label: 'Web SDK 1.0',
    path: '/sdk_ref/web/overview',
    openNested: true,
    submenu: [
      { label: 'Overview', path: '/sdk_ref/web/overview' },
      {
        label: 'Express API',
        path: '/sdk_ref/web/express',
        openNested: true,
        submenu: [
          { label: 'Channel', path: '/sdk_ref/web/express-channel' },
          { label: 'Room', path: '/sdk_ref/web/express-room' },
          { label: 'PCast™', path: '/sdk_ref/web/express-pcast' },
        ],
      },
      {
        label: 'Low-Level API',
        path: '/sdk_ref/web/low-level',
        openNested: true,
        submenu: [
          { label: 'Room', path: '/sdk_ref/web/room' },
          { label: 'Chat', path: '/sdk_ref/web/chat' },
          { label: 'PCast™', path: '/sdk_ref/web/pcast' },
        ],
      },
    ],
  },
  {
    label: 'Web SDK 2.0',
    path: '/sdk_ref/web/next-gen-overview',
    openNested: true,
    submenu: [
      { label: 'Overview', path: '/sdk_ref/web/next-gen-overview' },
      { label: 'Channel', path: '/sdk_ref/web/next-gen-channel' },
    ],
  },
  { label: 'Browser Support', path: '/sdk_ref/web/browser-support' },
  // { label: 'React Native Support', path: '/sdk_ref/web/react-native-support' },
  { label: 'Web Examples', path: '/sdk_ref/web/examples' },
  { label: 'Release Notes', path: '/sdk_ref/web/release-notes' },
];
